import { render, staticRenderFns } from "./server-list.vue?vue&type=template&id=4710580a&scoped=true&"
import script from "./server-list.vue?vue&type=script&lang=js&"
export * from "./server-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4710580a",
  null
  
)

export default component.exports